import React, { createContext, useContext } from "react";
import {
	type ShiftNavigatorManagerResult,
	useShiftNavigatorManager,
} from "../hook/useShiftNavigator";

const ShiftNavigatorContext = createContext<ShiftNavigatorManagerResult>({
	getShiftDataFromAPI: async () => {},
	initShiftNavigator: async () => {},
	moveShift: async () => {},
	shiftInfo: {
		AssetId: 0,
		CurrentShiftId: 0,
		CurrentProductionDate: new Date(),
		CurrentProductionShift: 0,
		CurrentShift: "",
		CurrentCrew: "",
		CurrentStart: new Date(),
		CurrentEnd: new Date(),
		PreviousShiftId: 0,
		PreviousProductionDate: new Date(),
		PreviousProductionShift: 0,
		PreviousShift: "",
		PreviousCrew: "",
		PreviousStart: new Date(),
		PreviousEnd: new Date(),
		NextShiftId: null,
		NextProductionDate: null,
		NextProductionShift: null,
		NextShift: null,
		NextCrew: null,
		NextStart: null,
		NextEnd: null,
		LastShiftId: 0,
		LastProductionDate: new Date(),
		LastProductionShift: 0,
		LastShift: "",
		LastCrew: "",
		LastStart: new Date(),
		LastEnd: new Date(),
	},
});

export const useShiftNavigator = () => useContext(ShiftNavigatorContext);

export const ShiftNavigatorProvider = ({ children }: any) => {
	const shiftNavigatorManager = useShiftNavigatorManager();

	return (
		<ShiftNavigatorContext.Provider value={shiftNavigatorManager}>
			{children}
		</ShiftNavigatorContext.Provider>
	);
};
